import { createContext, PropsWithChildren, useContext } from "react";

import { IdentityClient, IIdentityClient } from "@atlassiansox/asc-identity";

import { getApiPrivateUrl, getIdentityBaseUrl } from "../utils";

// this is a hack to keep this working for now, since we don't have
// client providers in magnolia yet
export const IdentityClientContext = createContext<IIdentityClient>(
    new IdentityClient({
        baseUrlStargate: getApiPrivateUrl(),
        baseUrlIdentity: getIdentityBaseUrl()
    })
);

export function useIdentityClient(): IIdentityClient {
    return useContext(IdentityClientContext);
}

export type IdentityClientProviderProps = PropsWithChildren<{
    readonly client: IIdentityClient;
}>;

export const IdentityClientProvider = ({
    client,
    children
}: IdentityClientProviderProps) => {
    return (
        <IdentityClientContext.Provider value={client}>
            {children}
        </IdentityClientContext.Provider>
    );
};
